// Capture native replaceState before TanStack Router patches it.
// Must be imported before the router is created.
export const nativeReplaceState = window.history.replaceState.bind(window.history);
